module.exports = __webpack_public_path__ + "static/media/service3.844490dc.jpg";